import { getSearchType } from '../../gtm/searchPageGtmBuildData'

/**
 * Build analyticsTags array for AlgoliaSearch on SERP
 *
 * @example
 * getSearchPageAlgoliaSearchAnalyticsTags('desktop', '?q=ibuprofen&i=1')
 * ['search', 'desktop', 'web', 'interne']
 */
export const getSearchPageAlgoliaSearchAnalyticsTags = (
  deviceType: string,
  searchParams: URLSearchParams,
): string[] => {
  const searchType = getSearchType(searchParams)

  return ['search', deviceType, 'web', searchType]
}
